//@flow
import FunctionStore from '../Base/functionStoreClass';
import { updateState } from '../Base/storeUtils';
import Constants from '../../constants';

import type { HandlerAdd, StoreState } from '../Base/functionStoreClass';

export default class ModalStore extends FunctionStore {
  isOpen(modal:string, defaultValue?:boolean):boolean {
    return _isOpen(this.getState(), modal, defaultValue);
  }

  getModalData(modal:string):{} {
    const state = this.getState();
    return state.getIn(['modalData', modal], {});
  }

  _setup(onSuccess:HandlerAdd, onError:HandlerAdd) {
    onSuccess(Constants.OPEN_MODAL, updateState(_openModal));
    onSuccess(Constants.CLOSE_MODAL, updateState(_closeModal));

    onSuccess(Constants.LOGIN, updateState(_closeLoginModal));
    onSuccess(Constants.CREATE_CUSTOMER_SUCCESS, updateState(_closeLoginModal));

    onError(Constants.CHECKOUT_WITH_AMAZON_PAY_SUCCESS, updateState(_respondToAmazonCheckoutFailure));
    onError(Constants.CREATE_ORDER_SUCCESS, updateState(_respondToOrderError));
  }
}

function _isOpen(state:StoreState, modal:string, defaultValue:boolean = false):boolean {
  return state.getIn(['modal', modal], defaultValue);
}

function _respondToAmazonCheckoutFailure(state:StoreState) {
  if (!_isOpen(state, Constants.AMAZON_CHECKOUT_ERROR_MODAL)) {
    _openModal(state, Constants.AMAZON_CHECKOUT_ERROR_MODAL);
  }
}

function _respondToOrderError(state:StoreState) {
  if (!_isOpen(state, Constants.PAYMENT_METHOD_MODAL)) {
    _openModal(state, Constants.PAYMENT_METHOD_MODAL);
  }
}

function _closeLoginModal(state:StoreState) {
  _closeModal(state, Constants.LOGIN_MODAL);
}

function _openModal(state:StoreState, modalData:string|Object) {
  if (typeof modalData === 'string') {
    return state.setIn(['modal', modalData], true);
  } else {
    state.setIn(['modal', modalData.name], true);
    state.setIn(['modalData', modalData.name], modalData.data);
  }
}

function _closeModal(state:StoreState, modal:string) {
  state.setIn(['modal', modal], false);
  state.deleteIn(['modalData', modal]);
}
